import * as React from 'react';
import { DatePicker, Input, Select } from 'antd';
import { Moment } from 'moment';
import { SelectValue } from 'antd/lib/select';
import bindAllOfThis from 'src/utils/BindThisHelper'; // 'this' binder
import ItemRangeDTO from 'src/models/generic/ItemRangeDTO';
import ObjectUtil from 'src/utils/ObjectUtil';
import "./LetterRangeSelector.less";

interface LetterRangeSelectorProps {
    value?: ItemRangeDTO<string>;
    /** Min/max ranges for the selectable values. Limits are inclusive, so 'J' lower limit will start at 'J' */
    // limits?: ItemRangeDTO<string>; // Removed because its just a bad idea
    placeholder?: ItemRangeDTO<string>;
    disabled?: boolean;
    /**
     * Indicates how the unusable letters should be handled
     *
     * Modes: Unselectable options will be rendered a certain in the dropdown, either Disabled or Hidden
     */
    renderMode?: "Disabled" | "Hidden";

    defaultValue?: ItemRangeDTO<string>;

    onChange?: (value: ItemRangeDTO<string>) => void;
}

class LetterRangeSelector extends React.PureComponent<LetterRangeSelectorProps> {
    private defaults: Partial<LetterRangeSelectorProps> = {
        placeholder: { lower: "Start", upper: "End" },
        renderMode: "Disabled",
        disabled: false
    };

    constructor(props: LetterRangeSelectorProps) {
        super(props);
        bindAllOfThis(this, LetterRangeSelector.prototype);
    }

    private getProps(props: LetterRangeSelectorProps = this.props) {
        return ObjectUtil.DeepMergeObjects(this.defaults, props);
    }

    private handleLeftOnChange(e: SelectValue) {
        let lower = e?.toString();
        let { upper } = this.props.value;

        this.setState({ lower });
        if (this.props.onChange) {
            this.props.onChange({ lower, upper });
        }
    }

    private handleRightOnChange(e: SelectValue) {
        let upper = e?.toString();
        let { lower } = this.props.value;

        this.setState({ upper });
        if (this.props.onChange) {
            this.props.onChange({ lower, upper });
        }
    }

    private renderLowerSelectOptions() {
        let props = this.getProps();
        // let lowerCharCode = this.props.limits?.lower?.charCodeAt(0) || "A".charCodeAt(0);
        // let upperCharCode = this.props.limits?.upper?.charCodeAt(0) || "Z".charCodeAt(0);
        let lowerCharCode = "A".charCodeAt(0);
        let upperCharCode = "Z".charCodeAt(0);

        // Limit based on other selection
        let limit = Math.min(upperCharCode, props.value?.upper?.charCodeAt(0) || upperCharCode);
        let charCodes = Array.from(Array(upperCharCode - lowerCharCode + 1).keys()).map(x => x + lowerCharCode);

        if (props.renderMode === "Hidden") {
            charCodes = charCodes.map(x => x <= limit ? x : null).filter(x => x);
        }

        return charCodes.map(x => {
            let letter = String.fromCharCode(x);
            return <Select.Option key={x} disabled={limit < x} value={letter}>{letter}</Select.Option>;
        });
    }

    private renderRightSelectOptions() {
        let props = this.getProps();
        let lowerCharCode = "A".charCodeAt(0);
        let upperCharCode = "Z".charCodeAt(0);

        // Limit based on other selection
        let limit = Math.max(lowerCharCode, props.value?.lower?.charCodeAt(0) || lowerCharCode);
        var charCodes = Array.from(Array(upperCharCode - lowerCharCode + 1).keys()).map(x => x + lowerCharCode);

        if (props.renderMode === "Hidden") {
            charCodes = charCodes.map(x => x >= limit ? x : null).filter(x => x);
        }

        return charCodes.map(x => {
            let letter = String.fromCharCode(x);
            return <Select.Option key={x} disabled={limit > x} value={letter}>{letter}</Select.Option>;
        });
    }

    render() {
        // Details on the showAction for the selects: https://github.com/ant-design/ant-design/issues/6873#issuecomment-439392727
        let { value, defaultValue, disabled, placeholder } = this.getProps();

        return (
            <div className="letter-range-selector">
                <Input.Group compact>
                    <Select
                        className="left-box"
                        defaultValue={defaultValue?.lower}
                        value={value?.lower || undefined}
                        placeholder={placeholder?.lower}
                        disabled={disabled}
                        showSearch={true}
                        showArrow={false}
                        allowClear
                        onChange={this.handleLeftOnChange}
                        {...{ showAction: ["focus", "click"] }}
                    >
                        {this.renderLowerSelectOptions()}
                    </Select>
                    <Input className="center-box"
                        placeholder="To"
                        disabled
                    />
                    <Select
                        className="right-box"
                        defaultValue={defaultValue?.upper}
                        value={value?.upper || undefined}
                        placeholder={placeholder?.upper}
                        disabled={disabled}
                        showSearch={true}
                        showArrow={false}
                        allowClear
                        onChange={this.handleRightOnChange}
                        {...{ showAction: ["focus", "click"] }}
                    >
                        {this.renderRightSelectOptions()}
                    </Select>
                </Input.Group>
            </div>);
    }
}

export default  LetterRangeSelector;



// WEBPACK FOOTER //
// ./src/components/common/form/LetterRangeSelector.tsx